export default __webpack_public_path__ + "static/media/money.28e26f02.svg";